import { CircularProgress } from "@mui/material";
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from "react-redux";

// Custom styles for the DataTable
const customStyles = {
  headCells: {
    style: {
      fontSize: "12px",
      whiteSpace: "wrap",
      overflow: "hidden",
      color: "#F2674A",
      fontWeight: 800,
      backgroundColor: "#F2674A1A",
      border: "none",
    },
  },
  cells: {
    style: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      border: "none",
      color: "white",
    },
  },
  pagination: {
    style: {
      color: "white",
      backgroundColor: "#F2674A1A",
      border: "none",
    },
  },
  noData: {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      backgroundColor: "#141414",
      border: "none",
    },
  },
  progress: {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#F2674A",
      backgroundColor: "#141414",
      border: "none",
    },
  },
};

export function CommonDataTable({
  data,
  totalRows,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  columns,
  onRowClicked,
  sortByKey,
  sortServer,
  ...props
}) {
  const { isLoading } = useSelector((state) => state.loading);
  const conditionalRowStyles = [
    {
      when: (row) => row.id === "total",
      style: {
        backgroundColor: "#f1f1f1",
        fontWeight: "bold",
      },
    },
  ];

  // column can be the column object; column.selector may be a string or a function
  const handleSort = (column) => {
    if (sortServer && sortByKey) {
      // Prefer an explicit sortField (string) when provided
      if (column && column.sortField) {
        sortByKey(column.sortField);
        return;
      }

      // If selector is a string (property name), pass it through
      if (column && typeof column.selector === "string") {
        sortByKey(column.selector);
        return;
      }

      // If selector is a function, pass the function to the parent so it can map
      if (column && typeof column.selector === "function") {
        sortByKey(column.selector);
        return;
      }
    }
  };

  return (
    <div>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        fixedHeaderScrollHeight="600px"
        conditionalRowStyles={conditionalRowStyles}
        onChangePage={(value) => {
          setPage(value);
        }}
        responsive={true}
        fixedHeader
        theme="dark"
        paginationPerPage={rowsPerPage}
        onChangeRowsPerPage={setRowsPerPage}
        paginationRowsPerPageOptions={[10, 25, 50]}
        paginationTotalRows={totalRows}
        onRowClicked={onRowClicked}
        progressPending={isLoading}
        customStyles={customStyles}
        sortServer={sortServer}
        onSort={handleSort}
        progressComponent={<CircularProgress size="20px" color="primary" />}
        {...props}
      />
    </div>
  );
}